import { DataService } from './../../services/data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  social: any;

  constructor(
    private data: DataService
  ) { }

  ngOnInit() {
    this.data.getSettings('configs').subscribe((res) => {
      if(res && res.data){
        this.social = res.data.social;
      }
    })
  }

  onActivate(){
    window.scroll(0,0);
  }
}
